import gql from 'graphql-tag';

export const CREATE_STOCK_DELIVERY_ITEM = gql`
    mutation createStockDeliveryItemMutation ($input: CreateStockDeliveryItemInput!) {
        createStockDeliveryItem(input: $input) {
            id
        }
    }
`;

export const ASSIGN_PURCHASE_ORDER_ITEM_TO_STOCK_DELIVERY = gql`
    mutation assignPurchaseOrderItemToStockDeliveryItem (
        $stockDeliveryId: ID!,
        $warehouseId: ID!,
        $warehouseProductId: ID!,
        $quantity: Int!,
        $purchaseOrderItemId: ID!,
        $purchaseOrderId: ID,
    ) { 
        assignPurchaseOrderItemToStockDeliveryItem (
            stockDeliveryId: $stockDeliveryId,
            warehouseId: $warehouseId,
            warehouseProductId: $warehouseProductId,
            quantity: $quantity,
            purchaseOrderItemId: $purchaseOrderItemId,
            purchaseOrderId: $purchaseOrderId,
        ) {
            id
            quantity
            expiryCaptureRequired
            expiryPolicyContext
        }
    }
`;
